/**
 * @generated SignedSource<<ae677cb2126f997c00106f70f7637e32>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type auth_useDefaultPath$data = {
  readonly " $fragmentSpreads": FragmentRefs<"auth_getDefaultPath">;
  readonly " $fragmentType": "auth_useDefaultPath";
};
export type auth_useDefaultPath$key = {
  readonly " $data"?: auth_useDefaultPath$data;
  readonly " $fragmentSpreads": FragmentRefs<"auth_useDefaultPath">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "status",
  "storageKey": null
},
v1 = {
  "kind": "Literal",
  "name": "first",
  "value": 0
},
v2 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "totalCount",
    "storageKey": null
  }
];
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "auth_useDefaultPath",
  "selections": [
    {
      "kind": "InlineDataFragmentSpread",
      "name": "auth_getDefaultPath",
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "confirmedEmail",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "passwordSetupRequired",
          "storageKey": null
        },
        (v0/*: any*/),
        {
          "alias": "activeContracts",
          "args": [
            {
              "kind": "Literal",
              "name": "filters",
              "value": {
                "statuses": [
                  "active",
                  "paused"
                ]
              }
            },
            {
              "kind": "Literal",
              "name": "first",
              "value": 1
            }
          ],
          "concreteType": "ContractConnection",
          "kind": "LinkedField",
          "name": "freelancerContracts",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "Contract",
              "kind": "LinkedField",
              "name": "nodes",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "enableTimesheets",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "allowExpensesAccess",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "paymentsEnabled",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "Firm",
                  "kind": "LinkedField",
                  "name": "firm",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "slug",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": "freelancerContracts(filters:{\"statuses\":[\"active\",\"paused\"]},first:1)"
        },
        {
          "alias": "offers",
          "args": [
            {
              "kind": "Literal",
              "name": "filters",
              "value": {
                "statuses": [
                  "offer_made"
                ]
              }
            },
            (v1/*: any*/)
          ],
          "concreteType": "ContractConnection",
          "kind": "LinkedField",
          "name": "freelancerContracts",
          "plural": false,
          "selections": (v2/*: any*/),
          "storageKey": "freelancerContracts(filters:{\"statuses\":[\"offer_made\"]},first:0)"
        },
        {
          "alias": "interviews",
          "args": [
            {
              "kind": "Literal",
              "name": "filters",
              "value": {
                "stage": "interview"
              }
            },
            (v1/*: any*/)
          ],
          "concreteType": "JobApplicationConnection",
          "kind": "LinkedField",
          "name": "freelancerJobApplications",
          "plural": false,
          "selections": (v2/*: any*/),
          "storageKey": "freelancerJobApplications(filters:{\"stage\":\"interview\"},first:0)"
        },
        {
          "alias": "screening",
          "args": [
            {
              "kind": "Literal",
              "name": "filters",
              "value": {
                "withJobScreening": true
              }
            },
            (v1/*: any*/)
          ],
          "concreteType": "JobApplicationConnection",
          "kind": "LinkedField",
          "name": "freelancerJobApplications",
          "plural": false,
          "selections": (v2/*: any*/),
          "storageKey": "freelancerJobApplications(filters:{\"withJobScreening\":true},first:0)"
        },
        {
          "alias": "applications",
          "args": [
            {
              "kind": "Literal",
              "name": "filters",
              "value": {
                "statuses": [
                  "job_application_sent",
                  "job_application_draft"
                ]
              }
            },
            (v1/*: any*/)
          ],
          "concreteType": "JobApplicationConnection",
          "kind": "LinkedField",
          "name": "freelancerJobApplications",
          "plural": false,
          "selections": (v2/*: any*/),
          "storageKey": "freelancerJobApplications(filters:{\"statuses\":[\"job_application_sent\",\"job_application_draft\"]},first:0)"
        },
        {
          "kind": "InlineDataFragmentSpread",
          "name": "user_isMember",
          "selections": [
            (v0/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "isMember",
              "storageKey": null
            }
          ],
          "args": null,
          "argumentDefinitions": []
        },
        {
          "kind": "InlineDataFragmentSpread",
          "name": "user_isClient",
          "selections": [
            (v0/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "isClient",
              "storageKey": null
            }
          ],
          "args": null,
          "argumentDefinitions": []
        },
        {
          "kind": "InlineDataFragmentSpread",
          "name": "user_isGuest",
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "guest",
              "storageKey": null
            },
            (v0/*: any*/)
          ],
          "args": null,
          "argumentDefinitions": []
        }
      ],
      "args": null,
      "argumentDefinitions": []
    }
  ],
  "type": "User",
  "abstractKey": null
};
})();

(node as any).hash = "2ffa25aee728b1d8de0fe16ff3378e48";

export default node;
